import { c as _c } from "react/compiler-runtime";
import { IcoUpload16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import readDroppedItems from '../read-dropped-items';
import { useDropTarget } from './use-drop-target';
export const useDragDropProps = () => {
  const $ = _c(3);
  const {
    dropTarget,
    setDropTarget
  } = useDropTarget();
  let t0;
  if ($[0] !== dropTarget || $[1] !== setDropTarget) {
    const onDrop = async e => {
      if (!e.dataTransfer.types.includes("Files")) {
        return;
      }
      e.preventDefault();
      setDropTarget(null);
      const nodes = await readDroppedItems(e.dataTransfer.items);
      if (nodes.length > 0) {
        dropTarget?.onDrop(nodes, dropTarget.position);
      }
    };
    t0 = {
      onDrop
    };
    $[0] = dropTarget;
    $[1] = setDropTarget;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export const DropOverlay = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "agentBuilder.skills"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 bg-accent/5" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoUpload16 color="accent" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-primary pointer-events-none">{t1}<div className="relative flex flex-col items-center gap-2 rounded-lg border-2 border-dashed border-accent p-6">{t2}<p className="text-label-2 text-accent">{t3}</p></div></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp($) {
  return $.dropFiles;
}